import SelectLocation from './SelectLocation';

export default SelectLocation;
